import SilentSignin from '../components/B2c/SilentSignin'
import { signInUpServiceConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

const SilentSigninWidget = injectWidget({
  widget: SilentSignin,
  serviceConfig: signInUpServiceConfig,
})

export default SilentSigninWidget
